import React from "react";

export interface YhCardProps {
  children: React.ReactNode;
  className?: string;
  padding?: boolean;
}

export const YhCard: React.FC<YhCardProps> = ({
  children,
  className = "",
  padding = true,
}) => {
  return (
    <div className={`yh-card ${padding ? "p-6" : ""} ${className}`}>
      {children}
    </div>
  );
};

export default YhCard;
